module.exports = __webpack_public_path__ + "img/pro-experience-modal.d64c37c1.svg";